import {UnstableCard as Paper} from '@yandex-delivery/blocks'
import {merge} from '@yandex-delivery/utils'
import React from 'react'

import {renderWidget} from '..'
import type {PaymentMethodWidgetProps as Props} from '../types'
import {PaymentCard} from './components/PaymentCard/index@mobile'
import {usePaymentMethodProps} from './hooks/usePaymentMethodProps'

export function PaymentMethod(props: Props): React.ReactElement {
  const {
    config: {additional_body, title_style},
  } = props
  const {fieldName, getBody} = usePaymentMethodProps(props)

  return (
    <Paper padding="none" radius="L">
      <PaymentCard
        getBody={getBody}
        name={fieldName}
        title={additional_body.title.items.map(item =>
          renderWidget(merge(item, {color: title_style.color, font_size: title_style.size})),
        )}
      />
    </Paper>
  )
}
